import { render } from "./ForgotUserView.vue?vue&type=template&id=fbd128a4"
import script from "./ForgotUserView.vue?vue&type=script&lang=js"
export * from "./ForgotUserView.vue?vue&type=script&lang=js"

import "./ForgotUserView.vue?vue&type=style&index=0&id=fbd128a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__